import { ArrowCircleDownSharp, ArrowCircleRightSharp, ArrowCircleUp, CancelRounded } from "@mui/icons-material";
import { useContext, useEffect, useRef, useState } from "react";
import { Prompt, Route } from "react-router";
import { CurrentPContext, OrderContext, TempOrderContext } from "../../../ContextApi/context";
import OrderChkSel from "./OrderChkSel";
import StepperList from "../../../DTechComp/StepperList";
import { toBeEmptyDOMElement } from "@testing-library/jest-dom/dist/matchers";
import TheMount from "../../../OrderSettings/TheMount";

import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import OrderFunctions from "../../../OrderSettings/OrderFunctions";
import myFunctions from "../../../myFunctions";
import ConnUrls from "../../../Connections/ConnectURL";

const ProductOptions = (props) => {

    const [order, setOrder] = useContext(OrderContext);
    const [currentPage, setCurrentPage] = useContext(CurrentPContext);
    const [prodSelect, setProdSelect] = useState();
    const [fullRowtxt, setFullRowtxt] = useState([]);
    const [isClosing, setIsClosing] = useState(false);
    const [validationErrors, setValidationErrors] = useState([]); // ✅ state לשגיאות וולידציה
    const [shouldOpenPopup, setShouldOpenPopup] = useState(false); // ✅ flag לפתיחת popup

    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const prevPopTimestampRef = useRef(null);
    const closedByBackRef = useRef(false);

    let specInOrder = [];

    const [tempOps, setTempOps] = useState([...props.product.prodOptions]);


    useEffect(() => {
        ///בודק שאין כבר הזמנה פתוחה, במידה ויש , פותח את המוצרים המוזמנים
        if (props.imInOrder) {
            let theord = order.Orders[props.inOrderIndex];
            if (theord != null) {
                getSetedOrder();
            }
        }

        setSelectionHeader();

    }, [])

    useEffect(() => {
        if (isClosing && prodSelect) {
            const element = document.getElementById('prodSel');
            if (element) {
                element.classList.remove('animate__slideInUp');
                element.classList.add('animate__slideOutDown');
            }
        }
    }, [isClosing]);


    useEffect(() => {
        // כשההזמנה מתרוקנת - נקה את האופציות
        if (order.Orders.length === 0) {
            let cleanOps = JSON.parse(JSON.stringify(props.product.prodOptions));
            cleanOps.forEach(opt => {
                opt.selected = Array.isArray(opt.selected) ? [] : 0;
            });
            setTempOps(cleanOps);
        }
    }, [order.Orders.length]);

    useEffect(() => {
        if (props.PopMeUp?.timestamp &&
            props.PopMeUp?.itemId === props.itemId) {

            const isNewPopup = prevPopTimestampRef.current !== props.PopMeUp.timestamp;

            if (isNewPopup) {
                // פתיחה חדשה של הפופ-אפ — אתחול בחירות
                prevPopTimestampRef.current = props.PopMeUp.timestamp;

                let cleanOps = JSON.parse(JSON.stringify(props.product.prodOptions));

                // ✅ אם המוצר בהזמנה - תמיד טען את הבחירות מההזמנה
                if (props.imInOrder) {
                    let theord = order.Orders[props.inOrderIndex];
                    if (theord != null && theord.ordProdID === props.itemId && theord.specials && theord.specials.length > 0) {
                        let count = 0;
                        cleanOps.forEach(ops => {
                            theord.specials.forEach(ord => {
                                if (ops.optionName == ord.optionName) {
                                    cleanOps[count].selected = JSON.parse(JSON.stringify(ord.spec));
                                }
                            });
                            count++;
                        });
                    }
                }
                // ✅ אם המוצר לא בהזמנה - וודא שהבחירות ריקות
                else {
                    cleanOps.forEach(opt => {
                        opt.selected = Array.isArray(opt.selected) ? [] : 0;
                    });
                }

                setTempOps(cleanOps);
                setIsClosing(false);
                setValidationErrors([]); // ✅ נקה שגיאות
            }

            // תמיד בנה מחדש את הפופ-אפ (גם כשרק tempMount השתנה)
            setShouldOpenPopup(true); // ✅ סמן שצריך לפתוח popup
        }
    }, [props.PopMeUp, props.tempMount])

    // ✅ useEffect שמאזין רק ל-shouldOpenPopup (לא ל-tempOps!)
    useEffect(() => {
        if (shouldOpenPopup) {
            // נותן זמן ל-React לעדכן את ה-state
            setTimeout(() => {
                prodOptionsChksSelect();
                setShouldOpenPopup(false);
            }, 0);
        }
    }, [shouldOpenPopup])


    // ✅ useEffect שמעדכן את הפופאפ כש-validationErrors משתנה
    useEffect(() => {
        if (prodSelect && validationErrors.length > 0) {
            // עדכן את הפופאפ כדי להציג את השגיאות
            prodOptionsChksSelect();
        }
    }, [validationErrors])


    useEffect(() => {
        // עדכן את ההזמנה רק אם המוצר כבר בהזמנה (לא בפעם הראשונה!)
        if (props.imInOrder) {
            const hasAnySelection = tempOps.some(opt =>
                opt.selected && opt.selected !== 0 && opt.selected.length > 0
            );

            if (hasAnySelection) {
                updateTheOrd();
            }
        }

        setSelectionHeader();

        // רענון הפופ-אפ כדי לעדכן את המחיר המוצג
        if (prodSelect && !isClosing) {
            setShouldOpenPopup(true);
        }
    }, [tempOps])

    // שחרור נעילת גלילה — קורא את המיקום ישירות מה-DOM
    const unlockScroll = () => {
        const scrollY = -parseInt(document.body.style.top || '0');
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.width = '';
        document.body.style.top = '';
        window.scrollTo(0, scrollY);
    };

    // נעילת גלילה כאשר הpopup פתוח
    useEffect(() => {
        if (isPopupOpen) {
            const scrollY = window.scrollY;
            document.body.style.overflow = 'hidden';
            document.body.style.position = 'fixed';
            document.body.style.width = '100%';
            document.body.style.top = `-${scrollY}px`;

            return () => unlockScroll();
        }
    }, [isPopupOpen]);

    // יירוט כפתור Back (אנדרויד + iPhone swipe) — סוגר פופאפ במקום לנווט אחורה
    useEffect(() => {
        if (isPopupOpen) {
            closedByBackRef.current = false;
            window.history.pushState({ productPopup: true }, '');

            const handlePopState = () => {
                closedByBackRef.current = true;
                closeWithoutAdding();
            };

            window.addEventListener('popstate', handlePopState);

            return () => {
                window.removeEventListener('popstate', handlePopState);
                if (!closedByBackRef.current) {
                    window.history.back();
                }
            };
        }
    }, [isPopupOpen]);

    useEffect(() => {

    }, [fullRowtxt])


    const getSetedOrder = () => {

        let tempOp = [...tempOps];  // יצירת עותק חדש
        let count = 0;
        tempOp.forEach(ops => {
            order.Orders[props.inOrderIndex].specials.forEach(ord => {
                if (ops.optionName == ord.optionName) {
                    tempOp[count].selected = [...ord.spec];  // גם כאן עותק
                }
            });
            count++;
        });

        setTempOps(tempOp);  // עדכון ה-state בצורה נכונה
    }

    ///עדכון ההזמנה
    const updateTheOrd = () => {

        let orderOptsRows = [];
        tempOps.forEach((el) => {

            // if (el.allowMulti) {
            if (el.selected != "" && el.selected != null) {
                let spec = [];

                el.selected.forEach(elem => {
                    if (el.splitSelection) {
                        spec.push({
                            servType: elem.servType,
                            addToPrice: elem.addToPrice,
                            splitSelected: elem.splitSelected,
                            itmsMount: elem.itmsMount,
                            withSauces: elem.withSauces,
                            Makat: elem.Makat
                        });
                    }
                    else {
                        spec.push({
                            servType: elem.servType,
                            addToPrice: elem.addToPrice,
                            itmsMount: elem.itmsMount,
                            withSauces: elem.withSauces,
                            Makat: elem.Makat

                        });
                    }

                });

                orderOptsRows.push({
                    optionName: el.optionName,
                    freeAdds: el.freeAdds,
                    spec: spec,
                    splitSelection: el.splitSelection,
                    nilveMakat: el.nilveMakat,
                })
            }

        });


        let theItm = order.Orders.findIndex(itm => itm.ordProdID == props.itemId);

        // **חישוב מחיר תוספות עם freeAdds - שימוש בפונקציה הקיימת**
        const tempItem = {
            prodPrice: props.product.prodPrice,
            mount: 1,
            specials: orderOptsRows,
            addsPrice: undefined
        };

        const tempOrder = { Orders: [tempItem] };
        const totalPrice = OrderFunctions.getOrderPrice(tempOrder);
        const tempAddsPrice = totalPrice - parseFloat(props.product.prodPrice);


        if (theItm != -1) {
            order.Orders[theItm].addsPrice = tempAddsPrice;
            order.Orders[theItm].specials = orderOptsRows;
            setOrder({ ...order })
        }
        else {
            // **שולח גם את המחיר המחושב!**
            props.tempOrderProds(orderOptsRows, tempAddsPrice);
        }

    }


    const setSelectionHeader = () => {

        let fROwBk = [];
        let count = 0;

        if (order.Orders[props.inOrderIndex] != null) {

            tempOps.forEach(ops => {

                order.Orders[props.inOrderIndex].specials.forEach(ord => {
                    if (ops.optionName == ord.optionName) {
                        //לא פיצה
                        if (ord.splitSelection !== true) {
                            !props.isMarket && fROwBk.push(`<span class="optHeader bold">${ord.optionName}<span/><br/>`);
                            for (let i = 0; i < ord.spec.length; i++) {
                                let bk = (`<span class="headORdTxt">
                                     ${!props.isMarket ? `<span class={"regular"}>${ord.spec[i].itmsMount > 0 ? `X ${ord.spec[i].itmsMount}` : ""}</span>` : ""}
                                    ${ord.spec[i].servType}
                            <span/><br/>`)
                                fROwBk.push(bk);
                            }
                        }
                        //פיצה
                        else {
                            fROwBk.push(`<span class="optHeader bold">${ord.optionName}<span/><br/>`);
                            fROwBk = OrderFunctions.getPizzaSplits(ord, fROwBk)
                        }

                    }
                });
                count++;
            });


            setFullRowtxt(fROwBk);
        }

    }

    //מסדר את עמוד הבחירה עם צ'ק בוקסים
    const setAsMulti = (item, index) => {

        let onBtn = (item.selected != "") ?
            "בחרתי " + item.selected.length :
            (item.optionBtnTx == "" || item.optionBtnTx == null) ? "בחירה" : item.optionBtnTxt;
        let bk =
            <div className={"addToOrderBtn pointing"}
                onClick={() => prodOptionsChksSelect(item, index)}>
                {onBtn}
            </div>

        return (bk)

    }


    // let rollDown = "";

    // const rollMe = () => {

    //     let inProdTxt = window.document.getElementsByClassName("rollItm");

    //     if (inProdTxt.length > 0) {

    //         rollDown = ((rollDown == "") ? "rollDown" : "");
    //         inProdTxt[0].className = "rollItm inProdTxt " + rollDown;
    //     }
    // }
    const closeWithoutAdding = () => {
        unlockScroll();
        setIsPopupOpen(false);
        setIsClosing(true);
        setValidationErrors([]);

        // ✅ נקה את הבחירות אם המוצר לא בהזמנה
        // חשוב: isClosing חייב להיות true לפני setTempOps
        // כי בpopstate (כפתור back) אין batching ב-React 17
        if (!props.imInOrder) {
            let cleanOps = JSON.parse(JSON.stringify(props.product.prodOptions));
            cleanOps.forEach(opt => {
                opt.selected = Array.isArray(opt.selected) ? [] : 0;
            });
            setTempOps(cleanOps);
        }

        setTimeout(() => {
            setProdSelect();
            setIsClosing(false);
        }, 500);
    }

    //הקומפוננטה הזו תמיד מורכבת לכל מוצר בתפריט, גם כשהפופאפ שלה סגור -
    //לכן חייבים להתנות ב-isPopupOpen, אחרת עשרות מופעים סגורים נרשמים במחסנית יחד עם הפתוח
    myFunctions.useEscapeKey(isPopupOpen ? closeWithoutAdding : null);

    // ✅ פונקציית וולידציה לבדיקת mustSelect
    const validateMustSelectOptions = () => {
        let errors = [];
        let hideCount = 0;
        const linkedHidden = getLinkedHidden(tempOps);

        tempOps.forEach((option, index) => {
            // בדיקה אם האופציה מוסתרת בגלל isPopOption
            if (option.isPopOption) {
                if ((option.selected && option.selected.length > 0) || option.linkedPop) {
                    hideCount = 0; // נבחר (או חוצץ "לפי בחירה") - אל תסתיר את מה שבא אחריו
                } else {
                    hideCount = parseInt(option.itemsEffected) || 0; // לא נבחר - הסתר את האופציות הבאות
                }
            } else if (hideCount > 0) {
                hideCount--; // האופציה הזאת מוסתרת - דלג עליה
                return; // אל תבדוק mustSelect על אופציה מוסתרת
            }

            // מוסתרת כי לא נבחר הפריט שפותח אותה
            if (linkedHidden.has(index)) return;

            // רק אם האופציה מוצגת למשתמש - בדוק mustSelect
            if (option.mustSelect) {
                // בדיקה אם יש בחירה
                if (!option.selected ||
                    (Array.isArray(option.selected) && option.selected.length === 0) ||
                    option.selected === 0 ||
                    option.selected === "") {
                    errors.push(index);
                }
            }
        });

        return errors;
    };

    // פונקציה לסגירה עם אנימציה
    const closeWithAnimation = () => {
        // ✅ בדיקת וולידציה לפני הוספה להזמנה
        const errors = validateMustSelectOptions();

        if (errors.length > 0) {
            setValidationErrors(errors);
            // עצור - אל תסגור את החלון ואל תוסיף להזמנה
            // סקרול לאופציה הראשונה עם שגיאה
            setTimeout(() => {
                // גלול לשדה החובה הראשון שלא נבחר
                const firstErrorIndex = errors[0];
                const errorElement = document.querySelector(`[data-option-index="${firstErrorIndex}"]`);
                if (errorElement) {
                    errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }, 100);
            return;
        }

        // אם הכל תקין - נקה שגיאות והמשך
        setValidationErrors([]);
        unlockScroll();
        setIsPopupOpen(false);

        // אם המוצר עדיין לא בהזמנה, חשב את הנתונים והעבר אותם ישירות!
        if (!props.imInOrder && props.addToOrder) {
            // חישוב התוספות
            let orderOptsRows = [];
            tempOps.forEach((el) => {
                if (el.selected != "" && el.selected != null) {
                    let spec = [];

                    el.selected.forEach(elem => {
                        if (el.splitSelection) {
                            spec.push({
                                servType: elem.servType,
                                addToPrice: elem.addToPrice,
                                splitSelected: elem.splitSelected,
                                itmsMount: elem.itmsMount,
                                withSauces: elem.withSauces,
                                Makat: elem.Makat
                            });
                        }
                        else {
                            spec.push({
                                servType: elem.servType,
                                addToPrice: elem.addToPrice,
                                itmsMount: elem.itmsMount,
                                withSauces: elem.withSauces,
                                Makat: elem.Makat
                            });
                        }
                    });

                    orderOptsRows.push({
                        optionName: el.optionName,
                        freeAdds: el.freeAdds,
                        spec: spec,
                        splitSelection: el.splitSelection,
                        nilveMakat: el.nilveMakat,
                    })
                }
            });

            // **חישוב מחיר תוספות עם תמיכה ב-freeAdds**
            // יצירת אובייקט זמני למוצר עם mount=1 כדי לקבל מחיר תוספות ליחידה
            const tempItem = {
                prodPrice: props.product.prodPrice,
                mount: 1,
                specials: orderOptsRows,
                addsPrice: undefined
            };

            // יצירת הזמנה זמנית
            const tempOrder = {
                Orders: [tempItem]
            };

            // שימוש בפונקציה הקיימת שיודעת לטפל ב-freeAdds!
            const totalPrice = OrderFunctions.getOrderPrice(tempOrder);
            const tempAddsPrice = totalPrice - parseFloat(props.product.prodPrice);

            // העבר את הנתונים ישירות ל-addToOrder
            props.addToOrder(orderOptsRows, tempAddsPrice);
        } else {
            // אם המוצר כבר בהזמנה - עדכן רגיל
            updateTheOrd();
        }

        setIsClosing(true);
        setTimeout(() => {
            setProdSelect();
            setIsClosing(false);
        }, 500);
    }
    // חישוב המחיר הכולל למוצר - שימוש בפונקציה הקיימת
    const calculateTotalPrice = () => {
        // יצירת אובייקט זמני של מוצר כמו שהוא מאוחסן בהזמנה
        const tempItem = {
            prodPrice: props.product.prodPrice,
            mount: props.imInOrder ?
                (order.Orders.find(o => o.orderItemId === props.itemId)?.mount || 1) :
                props.tempMount,
            specials: [],
            addsPrice: undefined
        };

        // המרת tempOps לפורמט של specials
        tempOps.forEach((option) => {
            if (option.selected && option.selected.length > 0) {
                tempItem.specials.push({
                    optionName: option.optionName,
                    freeAdds: option.freeAdds,
                    spec: option.selected,
                    splitSelection: option.splitSelection
                });
            }
        });

        // יצירת אובייקט הזמנה זמני
        const tempOrder = {
            Orders: [tempItem]
        };

        // שימוש בפונקציה הקיימת!
        return OrderFunctions.getOrderPrice(tempOrder).toFixed(2);
    };



    //יוצר עמוד בחירות צ'ק בוקסס
    const prodOptionsChksSelect = (itemId) => {

        //מעדכן קודם את הרשימה במידה ומדובר במוצר שהוזמן
        if (itemId != null) {
            let tempo = order.Orders.findIndex(ord => ord.ordProdID == itemId)

            if (tempo != -1) {
                order.Orders[tempo].specials.forEach((specitm) => {
                    let theOp = tempOps.findIndex(it => it.optionName == specitm.optionName)
                    if (theOp != -1) {
                        tempOps[theOp].selected = specitm.spec.map(s => ({ ...s }))
                    }
                })
            }

        }

        let hideCount = 0; // ✅ הזזתי לכאן כדי שיתאפס בכל קריאה

        //נלווים שמוסתרים כי לא נבחר הפריט שפותח אותם - הבחירות שלהם יבוטלו מההזמנה
        const linkedHidden = getLinkedHidden(tempOps);
        clearOptionsAt(linkedHidden);

        let allOpts = tempOps.map((item, index) => {

            if (!item.isPopOption && hideCount <= 0) {
                if (linkedHidden.has(index)) return null;

                return (
                    <OrderChkSel key={index} itm={item} indx={index}
                        showError={validationErrors.includes(index)}
                        ContCallBack={(cheksBack) =>
                            ChksSelected(cheksBack, index)} />
                )
            }
            else {
                if (item.isPopOption) {
                    //בחוצץ "לפי בחירה" ההסתרה לפי opens (linkedHidden) ולא לפי itemsEffected
                    if (item.selected.length > 0 || item.linkedPop) {
                        hideCount = 0;
                    }
                    else {
                        hideCount = parseInt(item.itemsEffected);
                        //מכיוון שיש חוצץ והוא לא מסומן, כל הבנים שלו יבוטלו מההזמנה
                        clearSubPopOptions(index + 1, parseInt(item.itemsEffected));
                    }

                    return (
                        <OrderChkSel key={index} itm={item} indx={index}
                            showError={validationErrors.includes(index)}
                            ContCallBack={(cheksBack) => {
                                ChksSelected(cheksBack, index);
                                // ✅ השתמש ב-setTimeout כדי למנוע לולאה אינסופית
                                setTimeout(() => {
                                    prodOptionsChksSelect();
                                }, 0);
                            }} />
                    )


                }
                else {
                    hideCount = hideCount - 1;
                }
            }

        })

        setIsPopupOpen(true);
        setProdSelect(
            <div className={`prodOptionsSelect animate__animated ${isClosing ? 'animate__slideOutDown' : 'animate__slideInUp'}`} id={"prodSel"}>
                <div className={"prodOptionsSelectWrap"}>

                    {/* אזור הגלילה - תמונה, כותרת ואופציות */}
                    <div className={"OptionsSelectWrap"}>
                        {/* Product Image */}

                        {props.imgLnk && (
                            <div className={"popupProductImageWrap"}>
                                <img
                                    src={props.imgLnk}
                                    alt={props.product.prodName}
                                    className={"popupProductImage"}
                                />
                                <button type="button" className={`btnReset backSd prodcloseBtn pointing`} aria-label="סגור" onClick={() => closeWithoutAdding()}>
                                    <img src="/PermanentImages/55.png" alt="" aria-hidden="true" />
                                </button>
                            </div>
                        )}

                        {/* Product Header */}
                        <div className={`headOnOptions bold big ${(!allOpts || allOpts.length === 0) ? 'noOptionsMode' : ''}`}>
                            <div className={""}>
                                {props.product.prodName}
                            </div>
                            {props.product.prodProducts && (
                                <div className={"mnuDivPrdcReg prodSText noPadding"}>
                                    <div className={`FirstFont inProdTxt smallFont`} style={{
                                        maxHeight: 'none',
                                        overflow: 'visible',
                                        whiteSpace: 'pre-wrap',
                                        wordBreak: 'break-word'
                                    }}>
                                        {props.product.prodProducts}
                                    </div>
                                </div>
                            )}
                            <br />
                        </div>

                        {/* אופציות - רק אם יש */}
                        {allOpts && allOpts.length > 0 && (
                            <div className={"OptionsSelectTheTops"}>
                                {allOpts}
                            </div>
                        )}
                    </div>

                    {/* אזור תחתון צף - Mount וכפתור המשך */}
                    <div className={`optionsBtnWrapFlout ${(!allOpts || allOpts.length === 0) ? 'noOptionsMode' : ''}`}>
                        <div className={"selectOpBtnWrap col-12"}>
                            {/* Mount - תמיד מוצג (לא בסופרמרקט) */}
                            {!props.isMarket && (
                                <div className="bottomMountSection col-4 onRight">
                                    {props.imInOrder ? (
                                        <TheMount
                                            itemId={props.itemId}
                                            remFromOrder={props.removeFromOrder}
                                        />
                                    ) : (
                                        <div className={"prodPlusMinus"}>
                                            <div className={"plusBtn"} onClick={() => props.setTempMount(props.tempMount + 1)}>+</div>
                                            <div className={"mountNum"}>{props.tempMount}</div>
                                            <div className={"minusBtn"} onClick={() => {
                                                if (props.tempMount > 1) {  // Minimum is 1
                                                    props.setTempMount(props.tempMount - 1);
                                                }
                                            }}>-</div>
                                        </div>
                                    )}
                                </div>
                            )}
                            <div className={"col-7 pointing onLeft"} onClick={() => closeWithAnimation()}>
                                <div className={"selectOpBtn selectOpBtnSmall col-12"} >
                                    <span className={"onRight spacePadRightVeryBig"}>הוסף להזמנה</span>
                                    <span className={"onLeft spacePadLeftVeryBig"}>{calculateTotalPrice()} ₪</span>
                                </div>
                                {validationErrors.length > 0 && (
                                    <div className={"selectOpBtnSmall col-12"}
                                        style={{
                                            color: '#f44336',
                                            textAlign: 'center',
                                            marginTop: '3px',
                                            fontSize: '14px',
                                            fontWeight: 'bold',
                                            padding: '0 10px',
                                            width: '100%',
                                            boxSizing: 'border-box',
                                            wordWrap: 'break-word',
                                            whiteSpace: 'normal'
                                        }}>
                                        יש למלא את כל שדות החובה
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* כפתורים תחתונים - רק אם המוצר בהזמנה */}
                        {props.imInOrder && (
                            <div className={"bottomButtonsRow"}>
                                {/* כפתור "עוד אחד עם שינויים" - רק אם יש אופציות */}
                                {allOpts && allOpts.length > 0 && (
                                    <div className={"duplicateButton pointing"}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            closeWithAnimation();
                                            setTimeout(() => {
                                                props.addDuplicate && props.addDuplicate();
                                            }, 500);
                                        }}>
                                        נוסף עם שינויים
                                    </div>
                                )}

                                {/* כפתור "הסר" - תמיד מוצג אם בהזמנה */}
                                <div className={"removeButton pointing"}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setIsPopupOpen(false);
                                        setIsClosing(true);
                                        setTimeout(() => {
                                            props.removeFromOrder && props.removeFromOrder(props.itemId);
                                            setProdSelect();
                                            setIsClosing(false);
                                        }, 500);
                                    }}>
                                    הסר מההזמנה
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )

    }


    //ContCallBack
    //נבחרו בחירות בעמוד בחירות של צק בוקסס
    const ChksSelected = (chekBxs, btnIndex) => {


        let tempOp = [...tempOps];
        let allChks = [];

        if (chekBxs.length > 0) {

            chekBxs.forEach(chk => {

                allChks.push(chk)
            });
            tempOp[btnIndex].selected = allChks;
        }
        else {
            tempOp[btnIndex].selected = "";
        }

        setTempOps(tempOp);
    }



    //חוצץ עם "כל בחירה פותחת נלווה משלה" (linkedPop): כל פריט בו פותח את הנלווים שב-opens שלו (לפי _id).
    //מחזיר את האינדקסים של הנלווים המקושרים שאף פריט שנבחר לא פותח
    const getLinkedHidden = (ops) => {
        let hidden = new Set();
        let idxOf = {};
        ops.forEach((op, i) => { if (op._id != null) idxOf[String(op._id)] = i; });

        ops.forEach((op, index) => {
            if (!op.linkedPop || !op.isPopOption) return;
            let sel = Array.isArray(op.selected) ? op.selected : [];
            let linked = new Set();
            let shown = new Set();
            (op.options || []).forEach(itm => {
                let isSel = sel.some(s => s.servType === itm.servType);
                (itm.opens || []).forEach(id => {
                    let t = idxOf[String(id)];
                    if (t == null || t === index) return;
                    linked.add(t);
                    if (isSel) shown.add(t);
                });
            });
            linked.forEach(t => { if (!shown.has(t)) hidden.add(t); });
        });
        return hidden;
    }

    const clearOptionsAt = (indices) => {
        let tempOp = [...tempOps];
        let hasChanges = false;
        indices.forEach(index => {
            if (tempOp[index] && tempOp[index].selected && tempOp[index].selected.length > 0) {
                tempOp[index].selected = "";
                hasChanges = true;
            }
        });
        if (hasChanges) setTempOps(tempOp);
    }

    const clearSubPopOptions = (startIndx, untilInt) => {
        let tempOp = [...tempOps];
        let hasChanges = false;
        for (let index = startIndx; index < startIndx + untilInt; index++) {
            if (tempOp[index].selected !== "") {
                tempOp[index].selected = "";
                hasChanges = true;
            }
        }
        if (hasChanges) setTempOps(tempOp);
    }


    return (
        <div className={"prodOptions"}>
            {prodSelect}
        </div>
    );
}

export default ProductOptions;